module.exports = __webpack_public_path__ + "img/fr.d5c12041.png";